import React from 'react';
import Modal from 'react-modal';
import CancelIcon from '@material-ui/icons/Cancel';
import Styled from './styles';
import { Typography } from '../../../typography';
import { useGlobalModalContext } from '../..';
import barrage from '../../../../assets/images/barrage.png';
import colors from '../../../../assets/colors';
import MUIButton from '../../../mui-button';
import CloseIcon from "@material-ui/icons/Close";

export const ConfirmModal = () => {
	const { hideModal, store } = useGlobalModalContext();
	const { modalProps } = store || {};
	const { title, confirmBtn, confirmCallback } = modalProps || {};

	const handleModalToggle = () => {
		hideModal();
	};

	return (
		<Modal isOpen={true} className={'Settings'}>
			<Styled.ModalContent>
				<Styled.Close onClick={handleModalToggle}>
					<CloseIcon style={{ color: colors.black }} />
				</Styled.Close>
				<div>
					<img src={barrage} style={{ height: 220, marginBottom: 10 }} alt="" />
				</div>
				<div style={{ maxWidth: '50%', textAlign: 'center' }}>
					<Typography text={title} />
				</div>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						width: '100%',
						marginTop: 50,
						gap: 20,
					}}
				>
					<MUIButton title="Back" callBack={handleModalToggle} />
					<MUIButton
						title={confirmBtn}
						callBack={() => {
							confirmCallback();
							handleModalToggle();
						}}
						variant="outlined"
						color="black"
						backgroundColor="none"
						image={
							confirmBtn === 'Delete' ? (
								<CancelIcon
									fontSize="small"
									style={{ color: colors.red, marginRight: 10 }}
								/>
							) : null
						}
					/>
				</div>
			</Styled.ModalContent>
		</Modal>
	);
};
